import { defineAction } from '~/prix'
import { z } from 'zod'
import waterSourceApplicationUpdateAction from './waterSourceApplicationUpdate.action.json' with { type: 'json' }
import { waterSourceApplicationObject } from '../waterSourceApplicationObject'

const waterSourceApplicationUpdateDefinition = defineAction({
  ...waterSourceApplicationUpdateAction,

  input: waterSourceApplicationObject
    .pick({
      id: true,
      citizenId: true,
      incentiveType: true,
      value: true,
      bankHolderName: true,
      bankHolderDocument: true,
      bankName: true,
      bankBranch: true,
      bankAccount: true,
      observation: true,
    })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default waterSourceApplicationUpdateDefinition
